import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { I18nService } from "../../../../providers/i18n.service";
import { AppQuery } from "../../../../store/app.query";
import { DashboardService } from "../../store/dashboard.service";

@Component({
    selector: "nerri-user-menu",
    standalone: false,
    templateUrl: "user-menu.template.html",
    styleUrls: ["./user-menu.style.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuComponent {
    public currentAccount$ = this.appQuery.selectCurrentAccount();
    public isDevelopment$ = this.appQuery.select(x => x.serverState?.mode === "development");
    public isStaging$ = this.appQuery.select(x => x.serverState?.mode === "staging");

    public get currentLanguage(): string {
        return this.i18nService.getDefaultLang();
    }

    public get availableLanguages(): string[] {
        return this.i18nService.getAvailableLanguages();
    }

    constructor(
        private appQuery: AppQuery,
        private service: DashboardService,
        private i18nService: I18nService,
        private router: Router
    ) {}

    public clearCache(): void {
        this.service.clearCache().subscribe(() => window.location.reload());
    }

    public logout(): void {
        this.service.logout().subscribe(success => {
            if (success) {
                this.router.navigate(["/"]);
            }
        });
    }

    public updateLanguage(language: string): void {
        this.i18nService.setLanguage(language);
        window.location.reload();
    }
}
